<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script setup>
//import UserScalePage from "@/hooks/UserScalePage";
import {onMounted} from "vue";

const monitor = require("@/common/js/monitor/monitor");
//let opstion = {
//  targetX: 1920,
//  targetY: 1080,
//  targetRatio: 16 / 9,
//};
//UserScalePage(opstion);

onMounted(() => {
  //autofit.init({
  //  el: "#app",
  //  dw: 1920,
  //  dh: 1080,
  //  resize: true,
  //  ignore:[
  //
  //  ]
  //}, false);
  //console.log('mounted 尺寸', window.innerWidth, window.innerHeight);
  //window.addEventListener('resize', () => {
  //  //console.log('resize 尺寸再变化', window.innerWidth, window.innerHeight);
  //});

  // 监测
  monitor.init({
    baseUrl: "https://conviviality.omnimkt.com/monitor/moitor_api",
    unionid: "",
    openid: "",
    projectId: "9",
    projectName: "AFC",
    api_key: "22e5d83fd709093d4a8e3edd9842a1db551e3d9151cf01b0a3ec955e0f6d",
    currentPageUrl: window.location.href,
    ad_id: "",
    debug: true
  });
})

</script>

<style lang="scss">
@import "common/scss/fonts.scss";

html,
body {
  //max-width: 1920px;
  width: 100%;
  height: 100%;
  margin: 0 auto 0;
  overflow: hidden;
  position: relative;
  box-sizing: border-box;
  /* border: 5px solid red; */
}

#app {
  overflow: hidden;
  width: 100%;
  height: 100%;
}


img {
  -webkit-user-select: none; /* Safari */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* IE/Edge */
  user-select: none; /* 标准语法 */
}

.opacity0 {
  opacity: 0 !important;
  pointer-events: none;
  height: 0 !important;
  transition: opacity 0.3s;
  overflow: hidden;
}

.opacity1 {
  pointer-events: all;
  transition: opacity .3s;
  opacity: 1 !important;
  z-index: 9999;
}

.opacity00 {
  opacity: 0 !important;
  pointer-events: none;
  //height: 0 !important;
  transition: opacity .3s;
  overflow: hidden;
}

.opacity11 {
  pointer-events: all;
  transition: opacity 1s;
  opacity: 1 !important;
  z-index: 9999;
}


.el-scrollbar__view {
  position: relative;
  overflow: hidden;
}

.el-scrollbar__wrap {
  position: relative;
  //z-index: 2025;
  overflow-x: hidden !important;
}

.el-breadcrumb__inner {
  cursor: pointer !important;
}

.customPoperStyle {
  width: 420px !important;
  background: #1C1C1C !important;
  border: none !important;
  overflow: hidden !important;
}

.customPoperStyle .el-popper__arrow::before {
  width: 0 !important;
  height: 0 !important;
  transform: scale(0);
}

.customPoperStyle .el-select-dropdown__item.hover, .customPoperStyle .el-select-dropdown__item:hover {
  background: #262626 !important;
}

.customPoperStyle .el-select-dropdown__item {
  color: #BABABA !important;
  font-size: 22px !important;
  height: 50px !important;
  display: flex !important;
  align-items: center !important;
}

.el-message {
  z-index: 10000 !important;
}

.messageBox .el-message__content {
  font-size: 0.24rem !important;
  line-height: normal;
}

.messageBox.el-message {
  padding: 0 0.2rem;
}

.messageBox .el-message__icon {
  transform: scale(.5);
}

.el-loading-mask{
  z-index:20000 !important;
}

.mLoading .el-loading-spinner .circular {
  width: 0.5rem !important;
  height: 0.5rem !important;
}

.mLoading .el-loading-spinner .el-loading-text {
  font-size: 0.24rem !important;
}

.swiperContent p, .otherServiceBox p {
  padding: 0;
  margin: 0;
}

</style>
